module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/sepa-27747746d2ea42dc1b9cc8bd1e801002.svg";